import {CMSContentType} from "../../CMSType";
import {IContentMapper} from "../base.content";
import {ListContentMapper} from "./list";
import {ImageListContentMapper} from "./image-list";
import {DetailsContentMapper} from "./details";
import {TransfersContentMapper} from "./transfers";
import {HeaderTwoContentMapper} from "../../headers/header-two.content";
import {PlayerListContentMapper} from "./player-list";

export function cmsContentMapperFactory(type: CMSContentType): IContentMapper {
  switch (type) {
    case CMSContentType.list: return new ListContentMapper();
    case CMSContentType.imageList: return new ImageListContentMapper();
    case CMSContentType.transfers: return new TransfersContentMapper();
    case CMSContentType.playerList: return new PlayerListContentMapper();
    case CMSContentType.details: return new DetailsContentMapper();
    case CMSContentType.headerTwo: return new HeaderTwoContentMapper();
    default:
      console.log(type);
      throw 'Undefined mapper = ' + type;
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/mappers/index.ts